<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                    prop="provinceId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.provinceId"
                      filterable
                      clearable
                      placeholder="请选择省区"
                      style="width:100%"
                      @change="changeProvinceFun"
                    >
                      <el-option
                        v-for="item in provinceOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="城市"
                    prop="cityId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.cityId"
                      filterable
                      clearable
                      placeholder="请选择城市"
                      style="width:100%"
                      @change="changeCityFun"
                    >
                      <el-option
                        v-for="item in cityOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="档位"
                    prop="levelArr"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.levelArr"
                      multiple
                      placeholder="请选择档位"
                      style="width:100%"
                      @change="changeLevelFun"
                    >
                      <el-option
                        v-for="item in levelOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.levelNames"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="价格区间"
                    prop="priceRange"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.priceRange"
                      multiple
                      placeholder="请选择价格区间"
                      style="width:100%"
                      @change="changePriceRangeFun"
                    >
                      <el-option
                        v-for="item in priceRangeOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.priceRangeNames"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="采集人"
                    prop="collectUserId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.collectUserId"
                      filterable
                      clearable
                      placeholder="请选择采集人"
                      style="width:100%"
                      @change="changeCollectUserFun"
                    >
                      <el-option
                        v-for="item in collectUserOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.collectUserName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="状态"
                    prop="status"
                  >
                    <el-radio-group v-model="dialogAddEditViewForm.status">
                      <el-radio
                        :label="1"
                        :disabled="eventType==='view'"
                      >
                        启用
                      </el-radio>
                      <el-radio
                        :label="2"
                        :disabled="eventType==='view'"
                      >
                        停用
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-for="(item,index) in selectRangeList"
            :key="index"
            class="modal-box"
          >
            <h3 class="modal-title">
              {{ item.rangeName }}
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item label="品规">
                    <el-checkbox-group v-model="item.checkProduct">
                      <el-checkbox
                        v-for="p in item.productList"
                        :key="p.data"
                        :label="p.data"
                      >
                        {{ p.label }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// API
import { listAreaApi } from '@/api/v2/area';
import { listStoreLevelSettingApi } from '@/api/v2/storeLevelSetting'
import { listPriceRangeSettingApi } from '@/api/v2/priceRangeSetting'
import { listTobaccoInfoApi } from '@/api/v2/tobaccoInfo'
// 数据请求
import { initRetailMonitoringProductSettingApi, saveOrUpdateRetailMonitoringProductSettingApi } from '@/api/retailMonitoringProductSetting'
import { loadUserSelectDataByUserTypeApi } from '@/api/user'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        provinceId: [{ required: true, message: '请选项省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择城市', trigger: 'change' }],
        levelArr: [{ required: true, message: '请选择档位', trigger: 'change' }],
        priceRange: [{ required: true, message: '请选择价格区间', trigger: 'change' }],
        collectUserId: [{ required: true, message: '请选择采集人', trigger: 'change' }],
        status: [{ required: true, message: '请选择价格区间设置状态', trigger: 'change' }],
        remark: [{ max: 500, message: '备注内容最多输入500个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
      cityOptions: [],
      levelOptions: [],
      collectUserOptions: [],
      priceRangeOptions: [],
      selectRangeList: [],
      productList: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.provinceOptions = []
        this.cityOptions = []
        this.levelOptions = []
        this.collectUserOptions = []
        this.priceRangeOptions = []
        this.selectRangeList = []
        this.productList = []
        this.dialogAddEditViewForm = {
          provinceName: '',
          provinceId: null,
          cityName: '',
          cityId: null,
          levelArr: [],
          levelIds: '',
          levelNames: '',
          priceRange: [],
          priceRangeNames: '',
          productNames: '',
          collectUserName: '',
          collectUserId: null,
          status: 1,
          remark: ''
        }
        this.initCollectUserSelectData()
        this.initTobaccoSelectData()
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initRetailMonitoringProductSettingApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          if (key !== 'priceRange' && key !== 'levelArr')
            this.dialogAddEditViewForm[key] = data[key]
        }
        if (this.dialogAddEditViewForm.collectUserId === 0) this.dialogAddEditViewForm.collectUserId = null
        this.initCitySelectData(data.provinceId)
        this.initLevelSelectData(data.provinceId)
        if (data.levelIds.length > 0) {
          data.levelIds.split(',').forEach(item => {
            this.dialogAddEditViewForm.levelArr.push(Number(item))
          })
        }
        data.priceRangeNames.split(',').forEach(item => {
          let selectItem = this.priceRangeOptions.find(rItem => {
            return rItem.label === item
          })
          if (selectItem !== null && selectItem !== undefined)
            this.dialogAddEditViewForm.priceRange.push(selectItem.data)
        })
        data.retailMonitoringPriceRanges.forEach(rangeItem => {
          let selectRange = this.priceRangeOptions.find(item => {
            return item.data === rangeItem.priceRangeId
          })
          if (selectRange !== null && selectRange !== undefined) {
            let selectRangeObj = { rangeName: selectRange.label, rangeId: selectRange.data, checkProduct: [] }
            rangeItem.retailMonitoringProductDetails.forEach(detailItem => {
              selectRangeObj.checkProduct.push(detailItem.productId)
            })
            selectRangeObj.productList = []
            this.productList.forEach(productItem => {
              if (Number(productItem.retailPrice) >= Number(selectRange.minPrice) && Number(productItem.retailPrice) < Number(selectRange.maxPrice)) {
                selectRangeObj.productList.push({ label: productItem.name, data: productItem.id })
              }
            })
            this.selectRangeList.push(selectRangeObj)
          }
        })
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    // 初始化品规
    initTobaccoSelectData () {
      listTobaccoInfoApi({ status: 1 }).then(res => {
        this.productList = res.data
        this.initPriceRangeSettingData()
      })
    },
    // 初始省区下拉数据
    initProvinceSelectData () {
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择省区回调
    changeProvinceFun (val) {
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
      this.cityOptions = []
      this.levelOptions = []
      this.initCitySelectData(val)
      this.initLevelSelectData(val)
    },
    // 初始城市下拉数据
    initCitySelectData (val) {
      listAreaApi({ parentId: val, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择城市回调
    changeCityFun (val) {
      let selectItem = {}
      selectItem = this.cityOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.cityName = selectItem ? selectItem.label : ''
    },
    // 初始化档位
    initLevelSelectData (val) {
      listStoreLevelSettingApi({ provinceId: val }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.levelOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择档位
    changeLevelFun (val) {
      let selectLevelNames = ''
      let selectLevelIds = ''
      if (val.length > 0) {
        val.forEach(levelId => {
          let selectLevel = this.levelOptions.find(item => {
            return item.data === levelId
          })
          selectLevelNames += ',' + selectLevel.label
          selectLevelIds += ',' + selectLevel.data
        })
        selectLevelNames = selectLevelNames.substring(1)
        selectLevelIds = selectLevelIds.substring(1)
      }
      this.dialogAddEditViewForm.levelNames = selectLevelNames
      this.dialogAddEditViewForm.levelIds = selectLevelIds
    },
    // 初始化价格区间
    initPriceRangeSettingData () {
      listPriceRangeSettingApi({ status: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.priceRangeOptions.push({ label: item.name, data: item.id, minPrice: item.minPrice, maxPrice: item.maxPrice })
        })
        if (this.eventType !== 'view') {
          this.initProvinceSelectData()
        }
        if (this.eventType !== 'add') {
          this.initPageData()
        } else {
          this.loading = false
        }
      })
    },
    // 选择价格区间
    changePriceRangeFun (val) {
      this.selectRangeList = []
      let selectRangeName = ''
      if (val.length > 0) {
        val.forEach(rangeId => {
          let selectRange = this.priceRangeOptions.find(item => {
            return item.data === rangeId
          })
          selectRangeName += ',' + selectRange.label
          let selectRangeObj = { rangeName: selectRange.label, rangeId: selectRange.data, checkProduct: [] }
          selectRangeObj.productList = []
          this.productList.forEach(productItem => {
            if (Number(productItem.retailPrice) >= Number(selectRange.minPrice) && Number(productItem.retailPrice) < Number(selectRange.maxPrice)) {
              selectRangeObj.productList.push({ label: productItem.name, data: productItem.id })
            }
          })
          this.selectRangeList.push(selectRangeObj)
        })
        selectRangeName = selectRangeName.substring(1)
        this.dialogAddEditViewForm.priceRangeNames = selectRangeName
      }
    },
    // 初始采集人下拉数据
    initCollectUserSelectData () {
      loadUserSelectDataByUserTypeApi().then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.collectUserOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 采集人回调
    changeCollectUserFun (val) {
      let selectItem = {}
      selectItem = this.collectUserOptions.find(item => {
        return item.data === val
      })
      if (selectItem !== null && selectItem !== undefined) {
        this.dialogAddEditViewForm.collectUserName = selectItem.label
      } else {
        this.dialogAddEditViewForm.collectUserName = ''
      }
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          let hasNoSelect = false
          let noSelectRangeName = ''
          this.selectRangeList.forEach(rangeItem => {
            if (rangeItem.checkProduct.length === 0) {
              hasNoSelect = true
              noSelectRangeName = rangeItem.rangeName
            }
          })
          if (hasNoSelect) {
            this.$message({
              message: '请选择[' + noSelectRangeName + ']的品规',
              type: 'warning'
            })
            return false
          }
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '零售监测调查品规设置', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              let priceRangeData = []
              let productData = []
              let productNames = ''
              this.selectRangeList.forEach(rangeItem => {
                priceRangeData.push({ priceRangeId: rangeItem.rangeId, priceRangeName: rangeItem.rangeName })
                rangeItem.checkProduct.forEach(productId => {
                  let productObj = this.productList.find(item => {
                    return item.id === productId
                  })
                  productData.push({ priceRangeId: rangeItem.rangeId, productId: productId, productName: productObj.name })
                  productNames += ',' + productObj.name
                })
              })
              if (productNames.length > 0) productNames = productNames.substring(1)
              this.dialogAddEditViewForm.productNames = productNames
              this.dialogAddEditViewForm.priceRangeData = JSON.stringify(priceRangeData)
              this.dialogAddEditViewForm.productData = JSON.stringify(productData)
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateRetailMonitoringProductSettingApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
